export const iconFontAwesomeHumanitarianFilePdf = (
	<i className="fa-solid fa-file-pdf"></i>
);
